import CodeMirror, { placeholder } from "@uiw/react-codemirror";
import './SqlCodeMirror.css'
import { langs } from "@uiw/codemirror-extensions-langs";

const MIN_HEIGHT = 115;
const MIN_WIDTH = 300;

const SqlCodeMirror = ({size={}, doc, setDoc, isResizeActive=false, handleResizeStart, wrapperClassName='', className='', placeholderText=null}: any) => {
  return (
    <div style={{ height: `${(size.height || MIN_HEIGHT) + 40}px`, width: `${(size.width || MIN_WIDTH)}px` }} className={`editorWrapper ${wrapperClassName}`}>
      <CodeMirror
        className={`sql-code-editor-query ${className}`}
        value={doc.text}
        height={`${(size.height || MIN_HEIGHT)}px`}
        extensions={[
          langs.sql(),
          placeholder((placeholderText ?? "Your query will be created\nin this window")),
        ]}
        basicSetup={{ lineNumbers: false, foldGutter: false }}
        onChange={(value: any) => setDoc({ text: value })}
        readOnly
      />

      {isResizeActive && (
        <div onMouseDown={handleResizeStart} className="resizeHandle" />
      )}
    </div>
  );
};

export default SqlCodeMirror;
